<template>
  <v-footer padless>
    <v-card class="flex" flat tile>
      <v-card-text class="py-2 text-center">
        <v-divider class="mx-10 ma-2"></v-divider>
        <v-img :src="logo" max-height="40" contain/>
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<script>
export default {
  name: 'mainFooter',
  data: () => ({
   year: new Date().getFullYear(),
   mark: process.env.VUE_APP_NAME,
   logo: require('@/assets/logo_footer.jpg')
  })
}
</script>

<style scoped>
</style>
